import { Module, GetterTree, MutationTree } from 'vuex';

import { AudioPlayerState } from './audio-player-state.store';
import { mutations } from './audio-player-mutations.store';
import { IAudioPlayerState } from './audio-player-types.store';
import { getters } from './audio-player-getters.store';

export class AudioPlayerModule<RootState> implements Module<IAudioPlayerState, RootState>{
  namespaced: boolean;
  state: IAudioPlayerState;
  getters: GetterTree<IAudioPlayerState, RootState>;
  mutations: MutationTree<IAudioPlayerState>;

  constructor() {
    this.namespaced = true;
    this.state = new AudioPlayerState();
    this.mutations = mutations;
    this.getters = getters;
  }
}